import PortalHeader from "./PortalHeader";
import LicensesFooter from "./LicensesFooter";

export default function PortalLayout({ children }) {
  return (
    <div className="min-h-screen br-aurora">
      <PortalHeader />
      <main className="pt-[72px]" data-testid="portal-main">
        {children}
      </main>
      <LicensesFooter />
    </div>
  );
}
